import { render, staticRenderFns } from "./MainMenu_v2.vue?vue&type=template&id=91ab3f6c&scoped=true"
import script from "./MainMenu_v2.vue?vue&type=script&lang=ts"
export * from "./MainMenu_v2.vue?vue&type=script&lang=ts"
import style0 from "./MainMenu_v2.vue?vue&type=style&index=0&id=91ab3f6c&prod&scoped=true&lang=css"
import style1 from "./MainMenu_v2.vue?vue&type=style&index=1&id=91ab3f6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ab3f6c",
  null
  
)

export default component.exports